const DYNAMIC_PRESETS = {
    LIFETIME: 'LIFETIME',
};

const DYNAMIC_PRESET_LABELS = {
    [DYNAMIC_PRESETS.LIFETIME]: 'Lifetime',
};

export { DYNAMIC_PRESETS, DYNAMIC_PRESET_LABELS };
